
import Vue from 'vue';
import { Component, Prop, ProvideReactive } from 'vue-property-decorator';
import CPDueDiligenceForm from './CPDueDiligenceForm.vue';
import CPDueDiligenceConfirmation from './CPDueDiligenceConfirmation.vue';
import CPDueDiligenceIntroduction from './CPDueDiligenceIntroduction.vue';
import { getAccountType } from '@/store/openAccount/support';

@Component({
    components: {
        CPDueDiligenceForm,
        CPDueDiligenceConfirmation,
        CPDueDiligenceIntroduction
    }
})
export default class CPDueDiligenceReminder extends Vue {
    @Prop({ type: Number, required: false })
    readonly userId!: number | null;

    @ProvideReactive()
    public get accountType() {
        return getAccountType(this.$store.state.dueDiligence.details.GeneralDetails.PlatformAccount.PlatformAccountType);
    }

    public get showConfirmation(): boolean {
        return this.$store.state.dueDiligence.openConfirmationModal;
    }

    public get showIntroduction(): boolean {
        return this.$store.state.dueDiligence.openIntroductionModal;
    }

    public get userInfoId(): number | null {
        return Number(this.userId ?? this.$store.state.account.details.userId);
    }
}
